export default __webpack_public_path__ + "static/media/Ballroll_00109.3f9958c1.png";